import axios from "axios";
import { isViewer } from "./permissions";

const REPORT_WHITELIST = [
  "/api/createexcelreport",
  "/api/employee-attendance-report/",
  "/api/create-inactive-employee-excel/",
  "/api/exit-slip/",
  "/api/login/",
  // Allow viewers to submit leave requests. The PUT (approve / reject) on this
  // same endpoint is still protected at the backend by an admin role check —
  // so whitelisting here only opens POST for the viewer, not approvals.
  "/api/leave-adjustment/",
];

const isReportUrl = (url = "") => REPORT_WHITELIST.some((p) => url.includes(p));

// URL patterns where viewer is allowed ONLY for POST (create). PUT / PATCH /
// DELETE on the same URL are still blocked. Used for "add-only" access — e.g.
// viewer can add a new employee but cannot edit/delete existing ones (both
// edit and delete hit the same /api/register-employee URL with different verbs).
const POST_ONLY_WHITELIST = [
  "/api/register-employee",
];

const isPostOnlyAllowed = (url = "", methodLower) =>
  methodLower === "post" && POST_ONLY_WHITELIST.some((p) => url.includes(p));

axios.interceptors.request.use((config) => {
  const method = (config.method || "get").toLowerCase();
  const isWrite = method === "post" || method === "put" || method === "patch" || method === "delete";
  const url = config.url || "";
  if (isWrite && isViewer() && !isReportUrl(url) && !isPostOnlyAllowed(url, method)) {
    const err = new Error("View-only role: write action is not allowed.");
    err.config = config;
    err.code = "VIEWER_BLOCKED";
    return Promise.reject(err);
  }
  return config;
});

// Wrap window.fetch so the same guard applies to non-axios calls
const originalFetch = window.fetch.bind(window);
window.fetch = (input, init = {}) => {
  const url = typeof input === "string" ? input : (input && input.url) || "";
  const methodUpper = (init.method || (typeof input === "object" && input.method) || "GET").toUpperCase();
  const isWrite = methodUpper === "POST" || methodUpper === "PUT" || methodUpper === "PATCH" || methodUpper === "DELETE";
  if (
    isWrite &&
    isViewer() &&
    !isReportUrl(url) &&
    !isPostOnlyAllowed(url, methodUpper.toLowerCase())
  ) {
    return Promise.reject(new Error("View-only role: write action is not allowed."));
  }
  return originalFetch(input, init);
};
